"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisClient = void 0;
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const uuid_1 = require("uuid");
const package_json_1 = require("../package.json");
class IrisClient {
    constructor(options) {
        this.isFlushingArtifacts = false;
        this.analyticsFlush = (cb) => __awaiter(this, void 0, void 0, function* () {
            yield this.flushQueue(this.analyticsQueue, 'analytics', cb);
        });
        this.artifactsFlush = (cb) => __awaiter(this, void 0, void 0, function* () {
            if (this.isFlushingArtifacts)
                return;
            this.isFlushingArtifacts = true;
            try {
                yield this.flushQueue(this.artifactsQueue, 'artifacts', cb);
            }
            finally {
                this.isFlushingArtifacts = false;
            }
        });
        this.FLUSH_INTERVAL = options.flushInterval;
        this.warnlog = options.warnlog;
        this.ANALYTICS_KEY = options.analyticsKey;
        this.env = options.env;
        this.service = options.service;
        this.artifactsQueue = [];
        this.analyticsQueue = [];
        this.timeout = null;
    }
    static getWrappedPayload(payload) {
        const timestamp = new Date().toISOString();
        return {
            anonymousId: payload.anonymousId,
            context: {
                library: 'trackjs',
                version: package_json_1.version,
            },
            event: payload.event,
            integrations: {},
            messageId: payload.messageId || (0, uuid_1.v4)(),
            originalTimestamp: timestamp,
            properties: payload.properties,
            receivedAt: timestamp,
            sentAt: timestamp,
            timestamp,
            type: 'track',
            userId: payload.userId,
        };
    }
    postEventsToSwitchboard(events, endpointType) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `https://${this.env === 'staging' ? 'staging.' : ''}switchboard.getpinwheel.com/v1/${endpointType}/${this.service}`;
            const res = yield (0, isomorphic_fetch_1.default)(url, {
                method: 'POST',
                body: JSON.stringify({ events }),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Trackjs-Analytics-Key': this.ANALYTICS_KEY,
                },
            });
            if (!res.ok) {
                throw new Error(`${res.status} Status`);
            }
            return res;
        });
    }
    enqueueAndFlush(queue, payload, flushFn, useInterval = true) {
        queue.push(IrisClient.getWrappedPayload(payload));
        if (useInterval) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(flushFn, this.FLUSH_INTERVAL);
        }
        else {
            flushFn();
        }
    }
    track(payload) {
        this.enqueueAndFlush(this.analyticsQueue, payload, this.analyticsFlush, true);
    }
    trackArtifacts(payload) {
        this.enqueueAndFlush(this.artifactsQueue, payload, this.artifactsFlush, false);
    }
    flushQueue(queue, endpoint, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!queue.length) {
                cb === null || cb === void 0 ? void 0 : cb();
                return;
            }
            // make a copy to avoid race conditions
            const events = [...queue];
            try {
                yield this.postEventsToSwitchboard(events, endpoint);
                queue.splice(0, events.length);
            }
            catch (e) {
                if (e instanceof Error)
                    this.warnlog(`iris_post_error: ${e}`, {
                        error: e === null || e === void 0 ? void 0 : e.message,
                        stack: e === null || e === void 0 ? void 0 : e.stack,
                    });
            }
            finally {
                cb === null || cb === void 0 ? void 0 : cb();
            }
        });
    }
    flush(cb) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.analyticsFlush(cb);
            yield this.artifactsFlush(cb);
        });
    }
}
exports.IrisClient = IrisClient;
